import { useQuery } from '@tanstack/react-query';

import { preferencesApi } from './api';
import { preferencesQueryKey } from './preferencesQueryKey';

const fetchMetricsPreferences = async (): Promise<string[]> => preferencesApi.getMetricsSettings();

export const useMetricsPreferencesQuery = () => {
  return useQuery<string[]>({
    queryKey: preferencesQueryKey.metrics(),
    queryFn: fetchMetricsPreferences,
  });
};

export type MetricsPreferencesQuery = ReturnType<typeof useMetricsPreferencesQuery>;
